<template>
  <router-view name="package" v-bind:key="$route.path"></router-view>
</template>

<script>
export default {
  name: "Package",
};
</script>
